import { FC, PropsWithChildren } from 'react';

import { RAProvider } from '../context/ra-provider';

export const ReservationAgreementCreateLayout: FC<PropsWithChildren> = ({
  children,
}) => {
  return <RAProvider>{children}</RAProvider>;
};
